import axios from 'axios';
import {getUserPool} from './cognito';
import {CognitoIdToken, CognitoAccessToken, CognitoRefreshToken, CognitoUserSession, CognitoUser} from 'amazon-cognito-identity-js';
import {IDENTITY_API} from 'utils/backend/server/api_library';

const validateOtpAuth = async (otp, email) => {
  const body = {password: otp, email};
  const url = `${IDENTITY_API}/auth/otp/validation`;
  const result = await axios.post(url, body);
  return result.data;
};

const loginWithOtp = async (otp, email) => {
  // call backend
  const result = await validateOtpAuth(otp, email);
  const {username, idToken, accessToken, refreshToken} = result;

  // save
  const userPool = await getUserPool();
  const cognitoIdToken = new CognitoIdToken({IdToken: idToken});
  const cognitoAccessToken = new CognitoAccessToken({AccessToken: accessToken});
  const cognitoRefreshToken = new CognitoRefreshToken({RefreshToken: refreshToken});

  const userSession = new CognitoUserSession({
    IdToken: cognitoIdToken,
    AccessToken: cognitoAccessToken,
    RefreshToken: cognitoRefreshToken,
  });

  const user = new CognitoUser({
    Username: username,
    Pool: userPool,
    // Storage: userPool.storage,
  });

  user.setSignInUserSession(userSession);
};

export {
  loginWithOtp,
};
